import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { IonButton, IonIcon, IonSpinner } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { informationCircleOutline, pencilOutline } from 'ionicons/icons';
import { Observable } from 'rxjs';
import { ParentHubStripe } from 'src/plugins/parent-hub-stripe';
import { PaymentInfo, PaymentStatus, SlipInfo } from '../../student-slip-modal.store';
import { FormState, HybridPaymentFormStore } from './hybrid-payment-form.store';

@Component({
  selector: 'app-hybrid-payment-form',
  templateUrl: './hybrid-payment-form.component.html',
  styleUrls: ['./hybrid-payment-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [HybridPaymentFormStore],
  imports: [NgClass, AsyncPipe, IonSpinner, IonIcon, IonButton]
})
export class HybridPaymentFormComponent implements OnInit, OnDestroy {
  @Input() set slipInfo(value: SlipInfo) {
    this.store.setSlipInfo(value);
  }
  @Input() set paymentInfo(value: PaymentInfo) {
    this.store.setPaymentInfo(value);
  }
  @Input() paymentStatus: PaymentStatus;
  @Output() paymentMethodUpdated = new EventEmitter<string>();
  @Output() readonly paymentStatusChange = this.store.paymentStatus$;

  readonly vm$: Observable<FormState> = this.store.vm$;

  constructor(private store: HybridPaymentFormStore) {
    addIcons({ pencilOutline, informationCircleOutline });
  }
  ngOnDestroy(): void {
    ParentHubStripe.removeAllListeners();
  }

  ngOnInit(): void {
    this.store.setPaymentStatus(this.paymentStatus);
    this.store.initialiseStripe();

    ParentHubStripe.addListener('paymentMethodChanged', (innerResult: any): void => {
      this.store.setPaymentMethod({
        methodId: innerResult.paymentMethodId,
        cardBrand: innerResult.cardBrand,
        cardLast4: innerResult.cardLast4
      });
      this.paymentMethodUpdated.emit(innerResult.paymentMethodId);
      this.store.setProgressError(null);
    });
    ParentHubStripe.addListener('applePayIntentRequired', (): void => {
      this.store.loadApplePayIntent();
    });
  }

  onEditAmount(): void {
    this.store.editAmount();
  }

  onChooseMethod(): void {
    this.store.chooseMethod();
  }
  onConfirm(): void {
    this.store.payNow();
  }
  onPayWithGooglePay(): void {
    this.store.payWithGooglePay();
  }
  onPayWithApplePay(): void {
    this.store.payWithApplePay();
  }
}
